import { render, staticRenderFns } from "./ViewInfo2.vue?vue&type=template&id=8a085e9e&scoped=true&"
import script from "./ViewInfo2.vue?vue&type=script&lang=js&"
export * from "./ViewInfo2.vue?vue&type=script&lang=js&"
import style0 from "./ViewInfo2.vue?vue&type=style&index=0&id=8a085e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a085e9e",
  null
  
)

export default component.exports